module.exports = __webpack_public_path__ + "img/home-img-5.60c95718.png";